<template>
    <div>
        <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ">1. Datos de recogida</h1>
        <br /><br />
        <br /><br />
        <h1 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">¿Quién lo envía? Danos tus datos</h1>
        


        <table>
            <tr>
                <td>
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                            <input style="color: #606060" v-model="datos.name" maxlength="40" size="60" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Nombre y apellidos * ">
                        </div>
                    </div>
                    <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.nameError }}</p>
                </td>
                <td>
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                            <input style="color: #606060" v-model="datos.telephone" maxlength="40" size="60" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Teléfono * ">
                        </div>
                    </div>
                    <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.telephoneError }}</p>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                            <input style="color:grey" v-model="email" maxlength="60" size="60" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Correo electrónico * ">
                        </div>
                    </div>
                    <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.mailError }}</p>
                    <template v-if="!this.$bus.login && mismoEmail">
                        <router-link to="/particularCR"
                                     class="link icon-green link--icon clickable">
                            <span style="font-family: Heebo; font-weight: normal">
                                Este cliente tiene una suscripción activa, para disfrutar su
                                suscripción, acceda con su usuario
                            </span>
                            <v-icon color="#9be51a">mdi-chevron-right</v-icon>
                        </router-link>
                    </template>
                </td>
                <td>
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                            <input style="color:grey" v-model="cif" maxlength="9" size="60" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="CIF/NIF/DNI *">
                        </div>
                    </div>
                    <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.cifError }}</p>
                    <template v-if="!this.$bus.login && mismoDNI && tipoDNI == 'DNI'">
                        <router-link to="/particularCR"
                                     class="link icon-green link--icon clickable">
                            <span style="font-family: Heebo; font-weight: normal">
                                Este cliente tiene una suscripción activa, para disfrutar su
                                suscripción, acceda con su usuario
                            </span>
                            <v-icon color="#9be51a">mdi-chevron-right</v-icon>
                        </router-link>
                    </template>
                </td>
            </tr>
            <tr>

                <td>
                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                            <input style="color:grey" v-model="datos.company" maxlength="100" size="60" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Nombre de la empresa">
                        </div>
                    </div>
                    <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.companyError }}</p>
                </td>
            </tr>

        </table>

        <br /><br />
        <br /><br />

        <h1 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">¿Dónde lo recogemos?</h1>



        <table>
            <tr>
                <td>
                    <div class="form-row">
                        <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                            <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                <input style="color: #606060" v-model="localCP" maxlength="5" type="number" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Código postal *">
                            </div>
                        </div>
                        <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.zipcodeError }}</p>
                    </div>
                </td>
                <td>
                    <div class="form-row">
                        <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                            <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                <input style="color: #606060" v-model="datos.address" maxlength="40" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Dirección, número, piso y escalera *">
                            </div>
                        </div>
                        <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ datos.addressError }}</p>
                    </div>
                </td>

            </tr>

            <tr>
                <td>
                    <div class="form-row">

                        <label style="font-family: Heebo; font-weight: normal; font-size: 14px">Población *</label>

                        <div v-if="mostrarInput" class="input-item">
                            <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                    <input style="color: #9BA19D;" v-model="poblacion" maxlength="40" type="text"
                                           name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual"
                                           placeholder="Se habilita al introducir un código postal válido">

                                </div>
                            </div>

                        </div>

                        <div v-else class="input-item">
                            <div class="input input--select input--s">
                                <select v-model="poblacion">
                                    <option v-for="pob in poblaciones" :key="pob.POBLACION" :value="pob.POBLACION" style="font-family: Heebo; font-weight: normal; color:black;">{{ pob.POBLACION }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </td>
                <td>
                    <div class="form-row">
                        <label style="font-family: Heebo; font-weight: normal;font-size:14px">Provincia *</label>
                        <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                            <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                <input style="color: #9BA19D;" v-model="provincia" maxlength="40" type="text" :readonly="readonly" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual"
                                       placeholder="Se autocompleta al seleccionar una población">
                            </div>
                        </div>

                    </div>
                </td>

            </tr>

        </table>



        <!-- EMPRESAS SIN REGISTRAR DIRECCION DE FACTURACION -->
        <template v-if="esEmpresaSR">
            <facturacion :facturacion="facturacion"></facturacion>
        </template>

    </div>
    
</template>

<script>
    import facturacion from "@/components/formulario/facturacion";

    export default {
        props: {
            datos: Object,
            facturacion: Object,
            tipoDNI: {
                type: String,
                default: "",
            },
        },

        components: {
            facturacion,
        },
        created() {
            this.getDNIsEmailsActivos();
        },
        computed: {
            hayCPs() {
                return this.$bus.CPs.length > 0;
            },
            esEmpresa() {
                return this.$bus.formulario.company;
            },
            esEmpresaSR() {
                return this.$bus.formulario.empresaSinRegistrar;
            },
            //Poblacion y provincia
            mostrarInput() {
                return (
                    this.datos.town != "" ||
                    this.localCP.length < 5 ||
                    !this.hayCPs ||
                    (this.esEmpresa && !this.cpEditado)
                );
            },
            readonly() {
                return this.hayCPs || (this.esEmpresa && !this.cpEditado);
            },
            backgroundColor() {
                return this.readonly ? "background-color:LightGrey;" : "";
            },
            localCP: {
                get() {
                    return this.datos.zipcode;
                },
                set(valor) {
                    this.datos.zipcode = valor;
                },
            },
            poblacion: {
                get() {
                    if (this.hayCPs && this.datos.town == "")
                        return "Se habilita al introducir un código postal válido";
                    return this.datos.town;
                },
                set(valor) {
                    if (this.hayCPs && valor != "")
                        this.provincia = this.poblaciones.filter(
                            (x) => x.POBLACION == valor
                        )[0].PROVINCIA;
                    this.datos.town = valor;
                },
            },
            provincia: {
                get() {
                    if (this.hayCPs && this.datos.province == "")
                        return "Se autocompleta al seleccionar una población";
                    return this.datos.province;
                },
                set(valor) {
                    this.datos.province = valor;
                },
            },
            cif: {
                get() {
                    return this.datos.cif;
                },
                set(valor) {
                    this.datos.cif = valor;
                    this.datos.cifError =
                        "El " + this.tipoDNI + " introducido no es válido";

                    if (this.tipoDNI == "DNI" && (this.isDNI(valor) || this.isNIE(valor)))
                        this.datos.cifError = "";
                    else if (
                        this.tipoDNI == "CIF/NIF/DNI" &&
                        (this.isCIF(valor) || this.isDNI(valor) || this.isNIE(valor))
                    )
                        this.datos.cifError = "";
                    this.mismoDNI = this.dnisEmailsActivos.some((x) => x.DNI == valor);
                },
            },
            email: {
                get() {
                    return this.datos.mail;
                },
                set(valor) {
                    this.datos.mail = valor;
                    this.mismoEmail = this.dnisEmailsActivos.some((x) => x.MAIL == valor);
                },
            },
        },
        data: () => ({
            cpEditado: false,
            dnisEmailsActivos: {},
            poblaciones: [],
            mismoDNI: false,
            mismoEmail: false,
            recogida: 0,
            tienda: null,
            tiendas: [],
        }),
        watch: {
            localCP(nuevoCP) {
                this.cpEditado = true;
                if (this.hayCPs) {
                    if (nuevoCP.length == 5)
                        this.poblaciones = this.$bus.CPs.filter((x) => x.CP == nuevoCP);
                    else {
                        this.poblaciones = [];
                        this.datos.town = "";
                        this.datos.province = "";
                    }
                }
            },
            recogida(v) {
                if (v == 1) {
                    this.tienda = null;
                    delete this.datos.idSfid;
                }
                if (v == 2) {
                    this.tienda = null;
                    this.poblaciones = [];
                    this.datos.town = "";
                    this.datos.province = "";
                    this.datos.address = "";
                    this.datos.zipcode = "";
                    delete this.datos.idSfid;
                }
            },
            tienda(v) {
                if (v) {
                    this.datos.town = v.poblacion;
                    this.datos.province = v.provincia;
                    this.datos.address = v.adress;
                    this.datos.zipcode = v.zipCode;
                    this.datos.idSfid = v.idSfid;
                }
            },
        },
        methods: {
            getDNIsEmailsActivos() {
                this.$API.getDNIsEmailsActivos().then((response) => {
                    if (response != "") {
                        //console.log(response)
                        //console.log(response.dnisEmailsActivos)
                        this.dnisEmailsActivos = response.dnisEmailsActivos;
                    }
                });
            },
            isDNI(nif) {
                return (
                    /^(\d{8})([A-HJ-NP-TV-Z])$/.test(nif) &&
                    "TRWAGMYFPDXBNJZSQVHLCKE"[RegExp.$1 % 23] == RegExp.$2
                );
            },
            isNIE(nie) {
                var nie_prefix = nie.charAt(0);

                switch (nie_prefix) {
                    case "X":
                        nie_prefix = 0;
                        break;
                    case "Y":
                        nie_prefix = 1;
                        break;
                    case "Z":
                        nie_prefix = 2;
                        break;
                }

                return this.isDNI(nie_prefix + nie.substr(1));
            },
            isCIF(cif) {
                if (!cif || cif.length !== 9) {
                    return false;
                }

                var letters = ["J", "A", "B", "C", "D", "E", "F", "G", "H", "I"];
                var digits = cif.substr(1, cif.length - 2);
                var letter = cif.substr(0, 1);
                var control = cif.substr(cif.length - 1);
                var sum = 0;
                var i;
                var digit;

                if (!letter.match(/[A-Z]/)) {
                    return false;
                }

                for (i = 0; i < digits.length; ++i) {
                    digit = parseInt(digits[i]);

                    if (isNaN(digit)) {
                        return false;
                    }

                    if (i % 2 === 0) {
                        digit *= 2;
                        if (digit > 9) {
                            digit = parseInt(digit / 10) + (digit % 10);
                        }

                        sum += digit;
                    } else {
                        sum += digit;
                    }
                }

                sum %= 10;
                if (sum !== 0) {
                    digit = 10 - sum;
                } else {
                    digit = sum;
                }

                if (letter.match(/[ABEH]/)) {
                    return String(digit) === control;
                }
                if (letter.match(/[NPQRSW]/)) {
                    return letters[digit] === control;
                }

                return String(digit) === control || letters[digit] === control;
            },
        },
    };
</script>

<style>
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }
    input::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal
    }
    ::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal
    }
    
    #recogida .v-input__slot {
        border: 0px solid white;
    }

</style>